// extracted by mini-css-extract-plugin
export default {"flex":"MoveInventoryDate_flex__lXRpk","title":"MoveInventoryDate_title__EJ7Gz","input_text":"MoveInventoryDate_input_text__UzNC5"};